// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"9e653250","339":"fe73e25a","484":"85992b56","551":"aaaaf1ad","617":"192af652","640":"cff99cac","851":"fac1d4cd","869":"c140b8b0","974":"6b3c0f67"}[chunkId] + ".chunk.js";
};